import { render } from "./MenuRow.vue?vue&type=template&id=df53cc8a&lang=pug"
import script from "./MenuRow.vue?vue&type=script&lang=js"
export * from "./MenuRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/menu/MenuRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df53cc8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df53cc8a', __exports__)) {
    api.reload('df53cc8a', __exports__)
  }
  
  module.hot.accept("./MenuRow.vue?vue&type=template&id=df53cc8a&lang=pug", () => {
    api.rerender('df53cc8a', render)
  })

}


export default __exports__